import { propFilter } from "@/util";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const initialState:propFilter={
    location:"",
    propertyType:"",
    priceRange:"",
    status:"",
    sort:"",
    propertyName:"",
    isSearch:false
}
const propertyFilterSlice=createSlice({
    name:"propertyFilter",
    initialState,
    reducers:{
        setLocation:(state,action:PayloadAction<string>)=>{
            return{...state,location:action.payload}
        },
        setPropertyType:(state,action:PayloadAction<string>)=>{
            return{...state,propertyType:action.payload}
        },
        setPriceRange:(state,action:PayloadAction<string>)=>{
            return{...state,priceRange:action.payload}
        },
        setStatus:(state,action:PayloadAction<string>)=>{
            return{...state,status:action.payload}
        },
        setSort:(state,action:PayloadAction<string>)=>{
            return{...state,sort:action.payload}
        },
        setSearch:(state,action:PayloadAction<boolean>)=>{
            return{...state,isSearch:action.payload}
        },
        setPropertyName:(state,action:PayloadAction<string>)=>{
            return{...state,propertyName:action.payload}
        },
        resetFilter: () => {
            return initialState;
        },
    }
});

export const {setLocation,setPropertyType,setPriceRange,setStatus,setSort,resetFilter,setSearch,setPropertyName}=propertyFilterSlice.actions;
export default propertyFilterSlice.reducer;